import axios from "axios";


export const auditLogs = async (authtoken, page = 1, limit = 10) => {
  return await axios.get(`${process.env.REACT_APP_API}/audit`, {
    headers: {
      Authorization: `Bearer ${authtoken}`,
    },
    params: { page, limit },
  });
};